<div class="table-footer">
    <span class="float-left inner-space-left-10">
        <ul class="pagination pagination-sm">
            <li class="page-item" [ngClass]="{'disabled': page <= 1}" (click)="previousPage()">
                <a aria-label="Previous" class="page-link">
                    <span aria-hidden="true" tabindex="-1">«</span>
                </a>
            </li>

            <ng-container *ngFor="let p of pages">
                <li *ngIf="p.canClick" class="page-item" [ngClass]="{'disabled': lastPage <= 1, 'active': p.value === page}"
                    (click)="changePage(p.value)">
                    <a class="page-link">
                        {{p.value}}
                    </a>
                </li>

                <li *ngIf="!p.canClick" class="page-item disabled">
                    <a class="page-link">
                        <span aria-hidden="true" tabindex="-1">{{p.value}}</span>
                    </a>
                </li>
            </ng-container>

            <li class="page-item" [ngClass]="{'disabled': lastPage <= 1 || page === lastPage}" (click)="nextPage()">
                <a aria-label="Next" class="page-link">
                    <span aria-hidden="true" tabindex="-1">»</span>
                </a>
            </li>
        </ul>
    </span>

    <span class="inner-space-right-10 footer-control">
        <select [(ngModel)]="pageSize" class="form-control size-select" (change)="changeNumberOfItemsPerPage()">
            <option *ngFor="let size of pageSizeOptions" [ngValue]="size">{{size}}</option>
        </select>
        <span class="entries-count" [i18n]="[{target: 'innerHTML', key: 'data-table.count', params: { count: items.length }}]"></span>
    </span>
</div>
